// Варианты анимаций для разных типов переходов
import { Variants } from 'motion';
import { TransitionType } from './ContentTransitionWrapper';

export const ANIMATION_VARIANTS: Record<TransitionType, Variants> = {
    fade: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
    },
    slide: {
        initial: {
            opacity: 0,
            x: 20,
        },
        animate: {
            opacity: 1,
            x: 0,
        },
        exit: {
            opacity: 0,
            x: -20,
        },
    },
    scale: {
        initial: {
            opacity: 0,
            scale: 0.95,
        },
        animate: {
            opacity: 1,
            scale: 1,
        },
        exit: {
            opacity: 0,
            scale: 0.95,
        },
    },
};